module.exports = __webpack_public_path__ + "img/pointA_item2.0ff231f1.png";